import React, { useRef } from "react";
import startDateIcon from "assets/img/brand/startdate_icon.png";
import companyNameIcon from "assets/img/brand/company_name_icon.png";
import surveyNumberIcon from "assets/img/brand/survey_number_icon.png";
import { Button, Col, Form, FormGroup, Input, InputGroup, Progress, Row } from "reactstrap";
import { useFormikContext } from "formik";
import moment from "moment";
import toast from "react-hot-toast";
import TextLimitIndicator from "components/TextLimitIndicator";
import Flatpickr from "react-flatpickr";
import { Icon } from "@iconify/react";

export function checkHasError(field) {
  return field !== undefined && field !== "";
}

function CompanyDetails({ formik, handleNext }) {
  const inputRef = useRef(null);

  return (
    <div className="w-100">
      <div className="d-flex justify-content-start my-2 w-100">
        <h5>Basic Details</h5>
      </div>

      <div className="w-100 my-2">
        <Row className="justify-content-between">
          <Col
            lg={6}
            xl={8}
            className="d-flex flex-wrap justify-content-between"
            style={{
              width: "100%"
            }}
          >
            <div className="d-flex">
              <img src={startDateIcon} alt="startDate icon" className="mr-3" />
              <div className="add_survey_startdate_label">
                Start Date
                <br />
                <span className="add_survey_startdate_value">
                  {moment(formik.values.startDate).format("MM/DD/YYYY")}
                  {/* 02/27/2025 */}
                </span>
              </div>
            </div>

            <div className="d-flex">
              <img src={surveyNumberIcon} alt="startDate icon" className="mr-3" />
              <div className="add_survey_startdate_label">
                Industry Name
                <br />
                <span className="add_survey_startdate_value">
                  {formik.values.industryName || "NA"}
                  {/* Information Technology */}
                </span>
              </div>
            </div>
            <div className="d-flex">
              <img src={companyNameIcon} alt="startDate icon" className="mr-3" />
              <div className="add_survey_startdate_label">
                Company Name
                <br />
                <span className="add_survey_startdate_value">
                  {formik.values.companyName || "NA"}
                  {/* ABC Pvt Ltd */}
                </span>
              </div>
            </div>
          </Col>
        </Row>
      </div>

      <Row className="border rounded my-4 p-2">
        <Col lg="6" className="mb-3">
          <FormGroup className="position-relative mb-0">
            <label>Mission Statement *</label>
            <textarea
              rows="4"
              className="form-control"
              placeholder="Enter Mission Statement"
              id="mission"
              name="mission"
              onChange={formik.handleChange}
              value={formik.values.mission}
              onBlur={formik.handleBlur}
              maxLength={500}
            />

            <TextLimitIndicator current={formik.values.mission.length} limit={500} />
          </FormGroup>
          {formik.touched.mission && formik.errors.mission ? (
            <div className="text-danger mt-2">{formik.errors.mission}</div>
          ) : null}
        </Col>
        <Col lg="6" className="mb-3">
          <FormGroup className="position-relative mb-0">
            <label>Vision Statement *</label>
            <textarea
              rows="4"
              className="form-control"
              placeholder="Enter Vision Statement"
              id="vision"
              name="vision"
              onChange={formik.handleChange}
              value={formik.values.vision}
              onBlur={formik.handleBlur}
              maxLength={500}
            />
            <TextLimitIndicator current={formik.values.vision.length} limit={500} />
          </FormGroup>
          {formik.touched.vision && formik.errors.vision ? (
            <div className="text-danger mt-2">{formik.errors.vision}</div>
          ) : null}
        </Col>
        <Col lg="12" className="mb-3">
          <FormGroup className="position-relative mb-0">
            <label>Company Overview *</label>
            <textarea
              rows="4"
              className="form-control"
              placeholder="Enter Vision Statement"
              id="companyOverview"
              name="companyOverview"
              onChange={formik.handleChange}
              value={formik.values.companyOverview}
              onBlur={formik.handleBlur}
              maxLength={1000}
            />

            <TextLimitIndicator current={formik.values.companyOverview.length} limit={1000} />
          </FormGroup>
          {formik.touched.companyOverview && formik.errors.companyOverview ? (
            <div className="text-danger mt-2">{formik.errors.companyOverview}</div>
          ) : null}
        </Col>
        <Col lg="12">
          <FormGroup className="growth-plan-date position-relative mb-0">
            <label>Company establishment date *</label>

            <Flatpickr
              required={true}
              id="companyEstablishmentDate"
              name="companyEstablishmentDate"
              placeholder="Select Company Establishment Date (MM-DD-YYYY)"
              onChange={(e) => {
                if (e.length === 0) {
                  formik.setFieldValue("companyEstablishmentDate", "");
                  return;
                }
                const date = moment(e[0]).format("MM-DD-YYYY");
                formik.setFieldValue("companyEstablishmentDate", date);
              }}
              ref={inputRef}
              value={formik.values.companyEstablishmentDate}
              options={{
                mode: "single",
                dateFormat: "m-d-Y",
                disableMobile: true,
                position: "top right",
                onClose: () => {
                  formik.setFieldTouched("companyEstablishmentDate", true);
                },
                onOpen: () => {
                  if (inputRef.current) {
                    setTimeout(() => {
                      inputRef.current?.flatpickr?.calendarContainer?.focus();
                    }, 50);
                  }
                }
              }}
              className="flatpickr datetimepicker form-control"
            />

            <Icon
              icon="uil:calender"
              width="20"
              height="20"
              className="position-absolute"
              style={{
                right: "0.5rem",
                top: "58%",
                cursor: "pointer"
              }}
              color="#6E6B7B"
              onClick={() => {
                if (inputRef?.current) {
                  inputRef?.current?.flatpickr?.open();
                }
              }}
            />
            {/* <Input
                id="companyEstablishmentDate"
                name="companyEstablishmentDate"
                placeholder="Select Company Establishment Date"
                type="date"
                innerRef={inputRef}
                onChange={formik.handleChange}
                value={formik.values.companyEstablishmentDate}
                onBlur={formik.handleBlur}
              /> */}
          </FormGroup>
          {formik.touched.companyEstablishmentDate && formik.errors.companyEstablishmentDate ? (
            <div className="text-danger mt-2">{formik.errors.companyEstablishmentDate}</div>
          ) : (
            <div className="mt-2"></div>
          )}
        </Col>
      </Row>

      <div className="d-flex justify-content-end mt-4">
        <button
          type="button"
          onClick={async () => {
            formik.setTouched({
              industryName: true,
              companyName: true,
              companyOverview: true,
              mission: true,
              vision: true,
              companyEstablishmentDate: true
            });

            formik.validateForm().then((response) => {
              if (
                checkHasError(response.industryName) ||
                checkHasError(response.companyName) ||
                checkHasError(response.companyOverview) ||
                checkHasError(response.mission) ||
                checkHasError(response.vision) ||
                checkHasError(response.companyEstablishmentDate)
              ) {
                toast("Please fill all the required fields before proceed further.", {
                  icon: "🚫"
                });
                return;
              } else {
                handleNext();
              }
            });
          }}
          className="btn btn-primary"
        >
          Next
        </button>
      </div>
    </div>
  );
}

export default CompanyDetails;
